import { BasicRequest } from "./basicRequest";

export class ReprocessFilesRequest extends BasicRequest{
    public fileIds!:number[]
    public filenameStartsWith!:string;
    public filenamecontains!:string;
}